<template>
  <!-- <a-popover :trigger="trigger">
    <template slot="title">
      <div>{{component.title}}</div>
      <div>{{component.name}}</div>
    </template>
    <template slot="content">
      <div class="component-detail-content">
        <img class="component-detail-content-img" :src="component.smallImg" />
      </div>
      <div class="component-detail">
        <a-row style="font-size: 10px">
          <a-col :span="3" class="popFontSize">作者:</a-col>
          <a-col :span="6" class="popFontSize">{{component.author}}</a-col>
          <a-col :span="6" class="popFontSize">上传时间:</a-col>
          <a-col :span="8" class="popFontSize">{{component.createTime}}</a-col>
        </a-row>
        <a-row>
          <a-col :span="2">
            <img :src="likeImg" class="popImg" alt=""  />
          </a-col>
          <a-col :span="4" class="popFontSize">{{component.likeNum}}</a-col>
          <a-col :span="2" :offset="2">
            <img :src="browseImg" class="popImg" alt=""  />
          </a-col>
          <a-col :span="4" class="popFontSize">313</a-col>
          <a-col :span="2" :offset="2">
            <img :src="uploadImg" class="popImg" alt=""  />
          </a-col>
          <a-col :span="4" class="popFontSize">{{component.downloadNum}}</a-col>
        </a-row>
      </div> -->
  <a-popover  :trigger="trigger" :placement="placement" overlayClassName="body__table_box">
    <template slot="content">
        <div class="body__table_box">
          <div class="body__oneform_box">
            <div class="card-title">
              <div class="body__oneform_info" :lines="undefined">
              {{component.title}}
              </div>
              <div class="body__oneform_info">
               {{component.name}}
              </div>
            </div>
          </div>
            <div class="component-detail-content">
                  <img
                    class="component-detail-content-img"
                    :src="component.isBuiltIn ? `/files/${component.imgUrl}` :component.smallImg"
                    alt=""
                  />
            </div>
          <div class="body__author_div">
            <div class="body__author_box">
              <span class="body__author_text" :lines="undefined">
                {{`作者:${component.author}`}}
              </span>
              <span class="body__author_uploadtime_text" :lines="undefined"
                >{{`上传时间:${component.createTime}`}}
              </span>
            </div>
            <div class="body-tags">
              <a-tag color="blue" v-for="(item, index) in 3" :key="index">
                pink
              </a-tag>
            </div>
            <div class="body__style_div">
              <div class="body__style_box" @click.stop="praiseAdd(item)">
                <img
                  class="body__give_like_image"
                  :src="
                    require(true ? '@/assets/component/list/imgpraise.png' : '')
                  "
                  alt=""
                />
                <span class="body__give_like_txt" :lines="undefined">
                  {{component.likeNum}}
                </span>
              </div>
              <div>
                <a-icon style="color: #999999" type="eye" />
                <span style="margin-left: 5px" class="body__give_like_txt"
                  >313</span
                >
              </div>
              <div class="body__download_div" @click.stop="downloadAdd">
                <img
                  class="body__download_icon"
                  :src="
                    require(true
                      ? '@/assets/component/list/img_32360_0_1.png'
                      : '')
                  "
                  alt=""
                />
                <span class="body__download_num" :lines="undefined"> {{component.downloadNum}} </span>
              </div>
            </div>
          </div>
        </div>
    </template>
    <div class="component-item-content">
      <img class="component-item-content-img" :src="component.isBuiltIn ? `/files/${component.imgUrl}` :component.smallImg" />
    </div>
  </a-popover>
</template>
<script>
export default {
  props:{
    component: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      placement: "top",
      trigger: "click",
      likeImg: require("@/assets/edit-page/like.png"),
      browseImg: require("@/assets/edit-page/browse.png"),
      uploadImg: require("@/assets/edit-page/upload.png"),
      arrayList: [
        {
          body__table_img: require("@/assets/component/list/img_32360_0_0.png"),
          body__oneform_info: "Form / Time selection",
          body__oneform_icon: require("@/assets/component/list/img_32360_0_4.png"),
          body__username_img: require("@/assets/component/list/img_32360_0_6.png"),
          body__username_text: "谭敏仪",
          body__username_time: "2020年4月3日",
          body__introduce_text:
            "全新一代数据可视化解决方案，致力于提供一套简单方便、专业可靠、无限可能的数据可视化最佳实践。",
          body__introduce_img: require("@/assets/component/list/img_32360_0_5.png"),
          body__author_text: "作者：vivi",
          body__author_uploadtime_text: "上传时间：2020-05-07",
          body__give_like_img: require("@/assets/component/list/img_32360_0_2.png"),
          body__give_like_image: require("@/assets/component/list/img_32360_0_3.png"),
          body__give_like_txt: "313",
          body__people_icon: require("@/assets/component/list/img_32360_0_65.png"),
          body__people_num: "313",
          body__download_icon: require("@/assets/component/list/img_32360_0_1.png"),
          body__download_num: "313",
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
@import "./popover.css";
</style>